var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"label":"File input","loading":"","hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }